import {
  type LibraryGroup,
  type LibraryDocType,
  type LibraryTemplate,
} from "@/utils/types";

export function getTemplateGroupByPath(
  libraryGroups: LibraryGroup["children"],
  groupPath: string[]
): LibraryGroup | LibraryDocType | undefined {
  const nextSubGroup = groupPath[0];
  if (!nextSubGroup) return undefined;

  for (const childKey of Object.keys(libraryGroups)) {
    if (childKey === nextSubGroup) {
      const nextChild = libraryGroups[childKey];

      if (groupPath.length === 1) {
        return nextChild;
      } else if (nextChild && "children" in nextChild) {
        return getTemplateGroupByPath(nextChild.children, groupPath.slice(1));
      } else {
        return undefined;
      }
    }
  }

  return undefined;
}

export function groupKeyToTitle(industryKey: string) {
  const sanitized = industryKey.replaceAll(/_/g, " ");
  const titleCase = sanitized
    .trim()
    .split(" ")
    .map((word) => (word[0]?.toUpperCase() || "") + word.slice(1))
    .join(" ");
  return titleCase;
}

export function createTemplateFileThumbnail({
  baseUrl,
  path,
  template,
}: {
  baseUrl: string;
  path: string[];
  template: LibraryTemplate;
}) {
  const thumbnail = `${baseUrl}/templates/${encodeURI(path.join("/"))}/refdocs/${template.refDocs[0]}.png`;
  return thumbnail;
}
